import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Projects.css';
import ProjectData from './ProjectData';
import { useTheme } from '../../contexts/ThemeContext';
import { FaBuilding, FaMapMarkerAlt, FaCalendarAlt, FaEye } from 'react-icons/fa';

const Projects = () => {
  const { theme } = useTheme();
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    setIsVisible(true);
  }, []);
  
  return (
    <div className='modern-projects-container'>
      {/* Hero Section */}
      <section className='projects-hero-section'>
        <div className='hero-background'></div>
        <div className='hero-overlay'></div>
        <div className='container hero-content'>
          <div className={`hero-text text-center ${isVisible ? 'animate-in' : ''}`}>
            <h1 className='hero-title'>
              <span className='text-gradient'>Our</span> Projects
            </h1>
            <p className='hero-description'>
              Showcasing excellence through our completed construction and manufacturing projects
            </p>
          </div>
        </div>
      </section>
      
      {/* Projects Gallery Section */}
      <section className='projects-gallery-section'>
        <div className='container'>
          <div className='section-header text-center mb-5'>
            <h2 className='section-title'>
              <FaBuilding className='section-icon' />
              <span className='text-gradient'>Completed</span> Projects
            </h2>
            <p className='section-description'>
              Explore our portfolio of successful construction and manufacturing projects
            </p>
          </div>
          <div className='projects-grid'>
            {ProjectData.map((project, index) => (
              <div key={project.id} className='project-card' data-aos='fade-up' data-aos-delay={index * 100}>
<div className='project-image'>
  {project.image?.[0] ? (
    <img src={project.image[0]} alt={`${project.title} project`} className='img-fluid' />
  ) : project.video ? (
    <video className='img-fluid' autoPlay muted loop>
      <source src={project.video} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  ) : (
    <div className='no-media-placeholder'>No Image Available</div>
  )}
</div>
                <div className='project-overlay'>
                  <div className='project-info'>
                    <h3 className='project-title'>{project.title}</h3>
                    <div className='project-meta'>
                      <span className='project-location'>
                        <FaMapMarkerAlt className='meta-icon' />
                        {project.location || 'Location'}
                      </span>
                      <span className='project-date'>
                        <FaCalendarAlt className='meta-icon' />
                        {project.year}
                      </span>
                    </div>
                    <Link to={`/project/${project.id}`} className='view-project-btn'>
                      <FaEye className='btn-icon' />
                      View Details
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Projects;
